import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Target, Sparkles, Coins, PenTool, Zap } from 'lucide-react';
export function Services() {
  const services = [{
    icon: Target,
    title: 'Strategy & GTM',
    lead: 'With Ginger',
    items: ['Positioning & messaging', 'Pricing strategy', 'Go-to-market planning', 'Product feedback', 'Competitive analysis']
  }, {
    icon: Sparkles,
    title: 'Design & Websites',
    lead: 'With Ashley',
    items: ['Websites & landing pages', 'Brand identity & logos', 'Social media templates', 'Presentation templates', 'Marketing materials']
  }, {
    icon: Coins,
    title: 'Investor Materials',
    lead: 'With Ashley + Ginger',
    items: ['Pitch decks', 'One-pagers & summaries', 'Investor updates', 'Data room setup', 'Financial models']
  }, {
    icon: PenTool,
    title: 'Content & Copy',
    lead: 'With Alicka',
    items: ['Website copy', 'Email sequences', 'LinkedIn content', 'Case studies', 'Ghostwriting']
  }, {
    icon: Zap,
    title: 'Automation & Tools',
    lead: 'With Kate',
    items: ['CRM setup (HubSpot, Zoho)', 'Email automations', 'Zapier workflows', 'Chat & support setup', 'Booking & scheduling']
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="services" className="py-32 bg-white" data-id="element-136">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-138">
          <span className="text-terracotta font-medium tracking-[0.2em] uppercase text-xs mb-4 block" data-id="element-139">
            What We Do
          </span>
          <h2 className="text-5xl md:text-6xl font-serif text-ink mb-6 font-normal" data-id="element-140">
            Four experts. Full coverage.
          </h2>
          <p className="text-lg text-ink/70 max-w-2xl mx-auto font-normal" data-id="element-141">
            Strategy, design, product, and content — all under one roof.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-142">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="h-full" data-id="element-143">
              <div className="p-8 h-full bg-paper flex flex-col" data-id="element-144">
                <div className="mb-6" data-id="element-145">
                  <service.icon className="w-6 h-6 text-terracotta" strokeWidth={1.5} data-id="element-146" />
                </div>

                <h3 className="text-xl font-serif font-normal text-ink mb-1" data-id="element-147">
                  {service.title}
                </h3>
                <p className="text-xs font-medium text-terracotta mb-6" data-id="element-148">
                  {service.lead}
                </p>

                <ul className="space-y-3 mt-auto" data-id="element-149">
                  {service.items.map((item, i) => <li key={i} className="text-sm text-ink/70 leading-snug font-normal" data-id="element-150">
                      {item}
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}